import React from 'react';
import Navbar from '../components/common/Navbar';
import Footer from '../components/home/Footer';

const TermsOfService: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />
      
      {/* Hero Section */}
      <div className="relative h-[30vh] min-h-[300px] bg-cover bg-center" style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url('/images/terms-hero.jpg')`
      }}>
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="text-center text-white">
            <h1 className="text-4xl md:text-5xl font-bold mb-4">Terms of Service</h1>
            <p className="text-xl max-w-2xl mx-auto px-4">Please read these terms carefully before using our services</p>
          </div>
        </div>
      </div>

      <div className="max-w-4xl mx-auto px-4 py-16">
        <div className="bg-white rounded-lg shadow-md p-8">
          <section className="mb-12">
            <h2 className="text-2xl font-bold mb-4">Agreement to Terms</h2>
            <p className="text-gray-700 mb-4">
              By accessing or using the services of Rion Wildlife Safaris, you agree to be bound by these Terms of Service. If you disagree with any part of these terms, you may not access our services.
            </p>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-bold mb-4">Booking and Payment Terms</h2>
            <div className="space-y-4">
              <div>
                <h3 className="text-lg font-semibold mb-2">Booking Confirmation</h3>
                <p className="text-gray-700">
                  Your booking is only confirmed upon receipt of:
                </p>
                <ul className="list-disc list-inside mt-2 text-gray-700 space-y-1">
                  <li>A completed booking form</li>
                  <li>The required deposit payment (30% of total tour cost)</li>
                  <li>Written confirmation from Rion Wildlife Safaris</li>
                </ul>
              </div>

              <div>
                <h3 className="text-lg font-semibold mb-2">Payment Schedule</h3>
                <ul className="list-disc list-inside text-gray-700 space-y-1">
                  <li>30% deposit required to secure booking</li>
                  <li>Full payment due 60 days before departure</li>
                  <li>Bookings made within 60 days require immediate full payment</li>
                </ul>
              </div>
            </div>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-bold mb-4">Cancellation Policy</h2>
            <div className="space-y-4">
              <p className="text-gray-700">
                Cancellation charges are calculated from the date we receive written notification:
              </p>
              <ul className="list-disc list-inside text-gray-700 space-y-2">
                <li>More than 60 days before departure: Loss of deposit</li>
                <li>59-30 days before departure: 50% of total tour cost</li>
                <li>29-15 days before departure: 75% of total tour cost</li>
                <li>14 days or less before departure: 100% of total tour cost</li>
              </ul>
              <p className="text-gray-700 mt-4">
                We strongly recommend purchasing comprehensive travel insurance to cover potential cancellation costs.
              </p>
            </div>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-bold mb-4">Tour Modifications</h2>
            <p className="text-gray-700 mb-4">
              Rion Wildlife Safaris reserves the right to:
            </p>
            <ul className="list-disc list-inside text-gray-700 space-y-2">
              <li>Alter tour itineraries due to weather, road conditions, or other circumstances</li>
              <li>Substitute accommodation of similar standard when necessary</li>
              <li>Cancel tours due to insufficient participants or force majeure</li>
            </ul>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-bold mb-4">Liability and Insurance</h2>
            <div className="space-y-4">
              <p className="text-gray-700">
                While we take all reasonable precautions to ensure your safety and enjoyment, you acknowledge that safari activities involve inherent risks. Rion Wildlife Safaris is not liable for:
              </p>
              <ul className="list-disc list-inside text-gray-700 space-y-2">
                <li>Personal injury, illness, or death</li>
                <li>Loss or damage to personal property</li>
                <li>Any damages resulting from force majeure events</li>
                <li>Changes to itinerary due to circumstances beyond our control</li>
              </ul>
              <p className="text-gray-700 mt-4">
                All participants must have comprehensive travel insurance covering medical emergencies, evacuation, and trip cancellation.
              </p>
            </div>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-bold mb-4">Participant Responsibilities</h2>
            <p className="text-gray-700 mb-4">
              You agree to:
            </p>
            <ul className="list-disc list-inside text-gray-700 space-y-2">
              <li>Follow all safety instructions provided by guides</li>
              <li>Respect wildlife and maintain safe distances</li>
              <li>Comply with local laws and customs</li>
              <li>Obtain necessary visas and travel documents</li>
              <li>Disclose relevant medical conditions</li>
              <li>Behave in a manner that does not disrupt the tour or other participants</li>
            </ul>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-bold mb-4">Photography and Media</h2>
            <p className="text-gray-700 mb-4">
              By participating in our tours, you grant Rion Wildlife Safaris permission to:
            </p>
            <ul className="list-disc list-inside text-gray-700 space-y-2">
              <li>Take photographs and videos during the tour</li>
              <li>Use such media for promotional purposes</li>
              <li>Share tour photographs on our website and social media</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold mb-4">Contact Information</h2>
            <p className="text-gray-700 mb-4">
              For questions about these Terms of Service, please contact us at:
            </p>
            <div className="text-gray-700">
              <p>Email: legal@rionwildlife.com</p>
              <p>Phone: +264 81 532 3450</p>
              <p>Address: Windhoek, Namibia</p>
            </div>
          </section>
        </div>

        <div className="mt-8 text-center text-gray-500 text-sm">
          Last updated: March 2025
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default TermsOfService; 